import { SafeGTMProperties } from "goi_common";

import {
  ExperimentVariation,
  HackleExperimentContainer,
} from "@/components/HackleExperimentContainer";

interface ABEnabledContainerProps {
  experimentKey: number;
  ComponentA: React.ReactElement;
  ComponentB: React.ReactElement;
  ComponentC?: React.ReactElement;
  onAssigned?: (variation: ExperimentVariation) => void;
  contextExtra?: SafeGTMProperties;
}

/**
 * @deprecated `HackleExperimentContainer`를 사용한다.
 *
 * 처치군을 ComponentA/B/C 개별 prop으로 받으면 처치가 늘어날 때마다 prop이 늘고,
 * 어떤 처치가 정의되지 않았는지도 드러나지 않는다. 새 컴포넌트는 variants 객체로 받는다.
 *
 * 기존 호출부 호환을 위해 남겨둔 어댑터다. 신규 코드에서는 쓰지 않는다.
 * ComponentC를 넘기지 않으면 C 할당자가 B를 보던 기존 동작을 그대로 유지한다.
 */
export const ABEnabledContainer = ({
  ComponentA,
  ComponentB,
  ComponentC,
  ...rest
}: ABEnabledContainerProps) => (
  <HackleExperimentContainer
    {...rest}
    variants={{ A: ComponentA, B: ComponentB, C: ComponentC ?? ComponentB }}
  />
);
